(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const pairs = [['menu', 'Menu'], ['search', 'Search']];
  for (const [name] of pairs) {
    let opener;
    document.addEventListener('click', (event) => {
      const dialog = document.querySelector(`[data-${name}-dialog]`);
      const trigger = event.target.closest(`[data-${name}-open]`);
      if (trigger && dialog?.showModal) {
        event.preventDefault(); opener = trigger;
        document.querySelectorAll('dialog[open]').forEach((other) => other.close());
        dialog.showModal(); trigger.setAttribute('aria-expanded', 'true');
      }
      if (event.target.closest(`[data-${name}-close]`)) dialog?.close();
      if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); }
    });
    document.addEventListener('close', (event) => {
      if (!event.target.matches(`[data-${name}-dialog]`)) return;
      opener?.setAttribute('aria-expanded', 'false');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    }, true);
  }
  const dropdowns = () => [...document.querySelectorAll('[data-header-dropdown]')];
  const closeDropdown = (dropdown, restoreFocus = false) => {
    dropdown.open = false;
    dropdown.querySelector('summary').setAttribute('aria-expanded', 'false');
    if (restoreFocus) dropdown.querySelector('summary').focus({ preventScroll: true });
  };
  document.addEventListener('toggle', (event) => {
    if (event.target.matches('[data-header-dropdown]')) event.target.querySelector('summary').setAttribute('aria-expanded', String(event.target.open));
  }, true);
  // Safari düzeltmesi (09.09.2026): Safari, bir bağlantıya/düğmeye tıklarken odağı
  // ona TAŞIMAZ — document.activeElement <body> olarak kalır. Eski hâlde bu, menü
  // açılır açılmaz "odak dışarı çıktı" sanılıp kapatılmasına yol açıyordu; tıklama
  // hedefe varamadığı için "Giriş yap" gibi bağlantılara basılamıyordu. Chrome odağı
  // taşıdığı için orada görünmüyordu. Artık odak GERÇEKTEN başka bir öğeye geçtiyse
  // kapatıyoruz; dışarı tıklamayı zaten aşağıdaki click dinleyicisi hallediyor.
  document.addEventListener('focusout', (event) => {
    const dropdown = event.target.closest('[data-header-dropdown]');
    if (!dropdown) return;
    requestAnimationFrame(() => {
      if (!dropdown.open) return;
      const focused = document.activeElement;
      if (!focused || focused === document.body || focused === document.documentElement) return;
      if (!dropdown.contains(focused)) closeDropdown(dropdown);
    });
  });
  document.addEventListener('click', (event) => {
    dropdowns().forEach((dropdown) => {
      if (dropdown.open && !dropdown.contains(event.target)) closeDropdown(dropdown);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dropdowns().filter(dropdown => dropdown.open).forEach(dropdown => closeDropdown(dropdown, true));
  });
})();
